import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';

import { App } from './App';
import './styles/globals.scss';

const root = document.getElementById('root');
if (!root) {
  throw new Error('Root element not found');
}

// OS-1713 — data router: habilita `useBlocker` (aviso de cambios sin guardar). Las rutas siguen
// declaradas en <App /> como rutas descendientes de este comodín.
const router = createBrowserRouter([{ path: '*', element: <App /> }]);

createRoot(root).render(
  <StrictMode>
    <RouterProvider router={router} />
  </StrictMode>,
);
